import {mapMutations, mapGetters, mapActions} from "vuex";
import _ from 'lodash';
import {directive as onClickaway} from 'vue-clickaway';

export default {
    name: "main-header",
    directives: {
        onClickaway: onClickaway,
    },
    data() {
        return {
            showLangList: false,
            showLangListMobile:false,
            enterSearch: false,
            payload: {
                search: ''
            }
        }
    },
    props: {
        item: {
            type: Object,
default: () => ({ phones: [], emails: [], instagram: '', facebook: '', address: '', map_link: '' })
        },
        menu: {
            type: Array,
            default: () => []
        }
        ,
    },
    methods: {
        ...mapMutations({
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',

        }),
        ...mapActions({
            search: 'category/SEARCH',
        }),
        closeLangList() {
            this.showLangList = false;
        },
        changeLanguage(code) {
            this.$setLanguage(code);
            this.showLangList = false;
            setTimeout(() => {
                window.location.reload();
            }, 800)
        },
        toggleOverlay: function () {
            const overlay = document.querySelector('.overlay')
            overlay.classList.toggle('open')
        },
        toggleBurger: function () {
            const burgerDeluxe = document.getElementById('burger_deluxe')
            burgerDeluxe.classList.toggle('open')
        },

        sendRequest: _.debounce(function () {
                if (this.payload.search.length > 2) {
                    this.search(this.payload.search)
                }
            },
            500),
        searchSubmit() {
            this.sendRequest();
            if (this.payload.search.length === 0) {
                this.searchResult.products = []
            }
        },
        isLetter(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[a-zA-Z0-9-а-яА-я-а-яєіїШЇЄІ ]*$/.test(char)) return true;
            else e.preventDefault();
        },
        isRegisterUser() {
            if (!this.isAuth) {
                console.log('false')
                this.changeShowPopUpLogin(true)
            } else {
                this.$router.push({name: 'user'}).catch(() => {
                    console.log('true')
                })
            }
        },
        showSearchInput() {
            this.enterSearch = !this.enterSearch
            this.payload.search = ''
            this.searchResult.products = []
        },
        isLogin() {
            // if (!this.isAuth) {
            //     this.changeShowPopUpLogin(true)
            // } else {
                this.$router.push({name: 'basket'}).catch(() => {

                })
            }
        // }
    },
    created() {

    },
    computed: {
        ...mapGetters({
            getCurrentOrder: 'order/getCurrentOrder',
            showPopUpRegister: `auth/showPopUpLogin`,
            isAuth: 'auth/isAuthenticated',
            searchResult: 'category/searchResult',
            orderInBasket: 'order/basket',
            languages: 'languages',
            currentLanguage: 'currentLanguage'
        }),
        isLogout() {
            return localStorage.getItem('user_token')
        },
    }
}
